import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { checkCkycStatus, readData } from "../../service/order/orderService";
import { evaluateKycResult, setParamsInURL } from "../../utils/helper";
import { paymentSummary } from "../../utils/router/constant";
import Loader from "../../components/common/loader";

const KycReturnPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const processedRef = useRef(false);

  useEffect(() => {
    // Prevent running multiple times
    if (processedRef.current) return;
    processedRef.current = true;

    const handleReturn = async () => {
      try {
        const searchParams = new URLSearchParams(location.search);

        // 1. Get orderId and memberId from query params or storage
        let orderId =
          searchParams.get("orderId") ||
          searchParams.get("order_id") ||
          localStorage.getItem("ckyc_order_id") ||
          sessionStorage.getItem("ckyc_order_id");

        let memberId =
          searchParams.get("memberId") ||
          searchParams.get("member_id") ||
          localStorage.getItem("ckyc_member_id") ||
          sessionStorage.getItem("ckyc_member_id");

        // Clear transient return flags
        localStorage.removeItem("ckyc_pending_return");
        sessionStorage.removeItem("ckyc_pending_return");
        localStorage.removeItem("ckyc_order_id");
        localStorage.removeItem("ckyc_member_id");
        sessionStorage.removeItem("ckyc_order_id");
        sessionStorage.removeItem("ckyc_member_id");

        if (orderId && orderId !== "undefined" && orderId !== "null") {
          // 2. Call backend to get the latest KYC status
          let ckycRes = null;
          try {
            ckycRes = await checkCkycStatus(memberId, orderId);
            await readData(orderId, "ODR").catch(() => {});
          } catch (err) {
            console.error("Failed to check CKYC status on return:", err);
          }

          const { isSuccess, isFailed, remarks } = evaluateKycResult(ckycRes);

          // 3. Trigger the toaster notification!
          if (isSuccess) {
            toast.success("KYC verified successfully!");
          } else if (isFailed) {
            toast.error(remarks || "KYC verification failed. Please try again.");
          } else {
            toast.info("KYC verification is under review.");
          }

          // 4. Navigate to Payment Summary page
          const params = await setParamsInURL(location, { orderId });
          navigate(`${paymentSummary}?${params}`, { replace: true });
        } else {
          navigate("/", { replace: true });
        }
      } catch (e) {
        console.error("Error processing KYC return:", e);
        navigate("/", { replace: true });
      }
    };

    handleReturn();
  }, [location, navigate]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#f8f9fa",
      }}
    >
      <Loader />
      <p style={{ marginTop: "1rem", color: "#6c757d", fontSize: "14px", fontWeight: 500 }}>
        Processing KYC verification, please wait...
      </p>
    </div>
  );
};

export default KycReturnPage;
